import DynamicPerimeter from './DynamicPerimeter'

export default DynamicPerimeter
